export default "__VITE_ASSET__BJx2F1tA__"